import AgentServices from '@/pages/AgentServices/Template'
import ServiceCharges from '@/pages/AgentServices/ServiceCharges'
import SetUpShop from '@/pages/AgentServices/SetUpShop'
import AddedServices from '@/pages/AgentServices/AddedServices'
import ShopAccounts from '@/pages/AgentServices/ShopAccounts'

export default {
    path: '',
    component: AgentServices,
    children: [
        {
            path: '/agentservices',
            name: 'AgentServices',
            component: AgentServices,
        },
        {
            path: '/agentservices/servicecharges',
            name: 'Service Charges',
            component: ServiceCharges,
        },
        {
            path: '/agentservices/setupshop',
            name: 'Set Up Shop',
            component: SetUpShop,
        },
        {
            path: '/agentservices/addedservices',
            name: 'Added Services',
            component: AddedServices,
        },
        {
            path: '/agentservices/shopaccounts',
            name: 'Shop Accounts',
            component: ShopAccounts,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/agentservices.js